<template>
  <div style="width: 100%; height: 100%">
    <el-switch v-model="isOpen" :active-text="$t('ntch21')" :inactive-text="$t('ntch22')" style="margin:16px" @change="isOpenPoint">
    </el-switch>
    <point-list :type="3" :pointList="list" />
  </div>
</template>


<script>
import PointList from '@/components/basics/PointList'
export default {
  name: "DevicePointList",
  props: {
    currentDetail: {
      type: Object
    }
  },
  components: {
    PointList
  },
  data() {
    return {
      isOpen: false,
      list: [],
    }
  },
  mounted() {
    this.init();
    this.sendCmd([{ type: "invoke_method", data: { methodName: "getGpsPlayOpen", methodParams: {} } }], "get");
    this.sendCmd([{ type: "invoke_method", data: { methodName: "getGpsPlayList", methodParams: {} } }], "get");
  },
  methods: {
    isOpenPoint(value) {
      this.sendCmd([{ type: "invoke_method", data: { methodName: "setGpsPlayOpen", methodParams: { status: value ? 1 : 0 } } }]);
    },
    init() {
      this.myWebSocket.onmessage = (val) => {
        let upresult = JSON.parse(val.data);
        if (upresult.type === "invoke_method") {
          const uri = upresult.data.uri;
          const data = JSON.parse(upresult.data.response);
          switch (uri) {
            case "getGpsPlayOpen": {
              this.isOpen = data.data.status ? true : false;
            } break;
            case "getGpsPlayList": {
              this.list = data.data;
            } break;
            default:
              break;
          }
        }
      }
    },
    sendCmd(commands_info, type = "set") {

      this.init();

      const { id, sn, type_id, name } = this.currentDetail;
      let devices_info = [{ id, sn, type_id, name, cache: {} }];

      this.$http.post("/admin/Command/generalCommand", {
        device_select_mode: "multiple",
        devices_info: encodeURIComponent(JSON.stringify(devices_info)),
        commands_info: encodeURIComponent(JSON.stringify(commands_info)),
        request_type: type
      }, () => {
        type === 'set' && this.$msg({ message: this.$t('ctcio22'), type: "success" });
      });
    },
  },
  computed: {
    myWebSocket() {
      return this.$store.getters.myWebSocket;
    },
  },
}

</script>